import { Crown } from 'lucide-react';

export default function ErnieProBadge({ className = '' }) {
  return (
    <div className={`inline-flex items-center gap-1 px-3 py-1 bg-gradient-to-r from-yellow-500 to-yellow-400 text-yellow-900 rounded-full text-sm font-bold shadow-lg ${className}`}>
      <Crown className="w-4 h-4" />
      PRO
    </div>
  );
}
